import { Button, Grid, makeStyles } from '@material-ui/core';
import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import Subtitle from '../ui-kit/Subtitle/Subtitle';
import { selectMeals, selectMealCount } from '~/store/legacy/selector/shoppingCartSelectors';
import Meal from './Meal';

const useStyles = makeStyles({
  header: {
    display: 'flex',
  },
  viewAll: {
    flexShrink: 0,
  },
});

const MealsSection = () => {
  const classes = useStyles();
  const [needsViewAll, setNeedsViewAll] = useState(false);
  const [isViewingAll, setIsViewingAll] = useState(false);
  const meals = useSelector(selectMeals);
  const mealCount = useSelector(selectMealCount);

  useEffect(() => {
    if (meals.length > 2) {
      setNeedsViewAll(true);
    }
  }, [meals]);

  const onViewAll = () => {
    setIsViewingAll(!isViewingAll);
  };

  const mealList = isViewingAll ? meals : meals.slice(0, 2);

  return (
    <section>
      <header className={classes.header}>
        <Subtitle hLevel={6} bottomMargin>
          Cart ({mealCount})
        </Subtitle>
        {needsViewAll && (
          <Button color='primary' className={classes.viewAll} onClick={onViewAll}>
            {isViewingAll ? 'View Less' : 'View All'}
          </Button>
        )}
      </header>

      <Grid container spacing={2}>
        {mealList.length > 0 &&
          mealList.map((meal) => (
            <Grid item xs={12} sm={6} key={meal.id}>
              <Meal meal={meal} />
            </Grid>
          ))}
      </Grid>
    </section>
  );
};

export default MealsSection;
